import useSWR from "swr";
import { notificationApi } from "../services/notification-api";
import {
  NotificationQueryDto,
  NotificationResponse,
  UnreadCountResponse,
} from "../types/notification.types";

const swrOptions = {
  dedupingInterval: 30000,
  revalidateOnFocus: false,
  revalidateOnReconnect: true,
  revalidateIfStale: false,
  refreshInterval: 60000,
  shouldRetryOnError: (error: unknown) => {
    if (error && typeof error === "object" && "status" in error) {
      return (error as { status: number }).status !== 429;
    }
    return false;
  },
  errorRetryCount: 1,
  errorRetryInterval: 10000,
  keepPreviousData: true,
} as const;

export function useNotifications(
  query?: NotificationQueryDto,
  enabled: boolean = true,
) {
  const { data, error, isLoading, mutate } = useSWR<NotificationResponse>(
    enabled ? ["notifications", query] : null,
    () => notificationApi.getAll(query),
    swrOptions,
  );

  return {
    data: data?.data ?? [],
    total: data?.total ?? 0,
    page: data?.page ?? 1,
    limit: data?.limit ?? 25,
    totalPages: data?.totalPages ?? 0,
    isLoading,
    isError: error,
    mutate,
  };
}

export function useUnreadNotificationsCount(enabled: boolean = true) {
  const { data, error, isLoading, mutate } = useSWR<UnreadCountResponse>(
    enabled ? ["notifications", "unread-count"] : null,
    () => notificationApi.getUnreadCount(),
    swrOptions,
  );

  return {
    count: data?.count ?? 0,
    isLoading,
    isError: error,
    mutate,
  };
}
